import { callApi, type ApiRequest, type ApiResponse } from '@/api/tenantClient';

export const attendeeCategoryListQueryKey = 'registration.attendeeCategoryList';
export const groupAttendeeCategoryListQueryKey = 'registration.groupAttendeeCategoryList';

export interface AttendeeCategoryData {
  id: number
  eventId: number
  name: string
  description: string
  registrationStrategy: RegistrationStrategyType
  isVisible: boolean
  groupRegistrationEnabled: GroupRegistrationEnabledType
}

export enum RegistrationStrategyType {
  FORMS_FIRST = 'forms_first',
  PAYMENT_FIRST = 'payment_first',
}

export interface AttendeeCategoryListQueryRequest {
  eventId: string
  group: boolean
}

export enum GroupRegistrationEnabledType {
  YES = 'yes',
  NO = 'no',
}

export function loadAttendeeCategoryList(createTenantRequest: () => ApiRequest) {
  const request = createTenantRequest();
  return async (params: AttendeeCategoryListQueryRequest): Promise<ApiResponse<AttendeeCategoryData[]>> => {
    request.method = 'GET';
    request.endpoint.path = '/api/v1/attendee_categories';
    request.endpoint.query = { eventId: params.eventId, group: params.group };
    return await callApi<AttendeeCategoryData[]>(request);
  };
}
